
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';

export default {
  name: 'ProductDetailWrapper',

  mixins: [eventTrackingMixins, lgmMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },

    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mounted() {
    // console.info('mounted...detail')
  },
  beforeUpdate() {
    const that = this;
    setTimeout(function () {
      that.handleEventTracking_promotionBannerLoaded();
    }, 2000);
  },
  updated() {
    // this.handleEventTracking_promotionBannerLoaded()
  },

  methods: {
    backToPreviousLink() {
      this.$router.go(-1);
    },

    handleEventTracking_promotionBannerLoaded() {
      const sponsoredPromotionItems = document.querySelectorAll('.sponsored-promotion');

      if (sponsoredPromotionItems?.length > 0) {
        // #4 count sponsoredPromotionItems

        sponsoredPromotionItems.forEach((element) => {
          const eventTrackingParams = this.initEventTrackingParams();

          const productData = this.extractDataFromCurrentProductDetailPage();

          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'promo_banner_impression';
          eventTrackingParams.l = productData?.product?.scenario_code;
          eventTrackingParams.c = `product_details_promo_banner`;
          eventTrackingParams.cd.insurer_name = productData?.product?.insurer_name;
          eventTrackingParams.cd.product_name = productData?.product?.product_name;
          eventTrackingParams.cd.product_category = productData?.product?.product_category;

          this.sendEventTracking(eventTrackingParams);
        });
      }
    },

    handleEventTracking_productDetailPage(event) {
      event.preventDefault();

      const dataFromClickedElement = this.extractDataFromClickedElement(event.target);

      const href = dataFromClickedElement?.href;

      const eventTrackingParams = this.initEventTrackingParams();

      if (dataFromClickedElement.tracking_target.target_code === 'product-card-link') {
        // #47 blog_related_products_card open_product_details
        const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute('data-insurer-company');
        const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute('data-product-id');
        const productName = dataFromClickedElement.offsetparent_node.getAttribute('data-product-name');
        const productCategory = dataFromClickedElement.offsetparent_node.getAttribute('data-product-category');
        eventTrackingParams.a = 'open_product_details';
        eventTrackingParams.l = productScenarioCode;
        eventTrackingParams.c = `blog_related_products_card`;
        eventTrackingParams.cd.insurer_name = insuranceCompany;
        eventTrackingParams.cd.product_name = productName;
        eventTrackingParams.cd.product_category = productCategory;

        window.open(href, "_blank");

      } else if (dataFromClickedElement.tracking_target.target_code === 'product-card-shortcut-link') {
        // #231 #231b Click Happy Kids Certification textlink leads to Happy Kids Main Page
        
        const currentUrl = window.location.href;

        if (!this.isProductDetailLink(currentUrl)) {
          // #231
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'to_family_site';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `decoder_card_cta`;
          eventTrackingParams.cd = {
            insurer_name: insuranceCompany,
            product_name: productName,
            product_category: productCategory,
          };
        } else {
          // #231b
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'to_family_site'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `product_details_cta`
          eventTrackingParams.cd = {
            insurer_name: insuranceCompany,
            product_name: productName,
            product_category: productCategory
          }
        }
      } else if (dataFromClickedElement.tracking_target.target_code === 'product-highlight-cta-link-product-website') {
        // #149 product-website
        const productData = this.extractDataFromCurrentProductDetailPage();
        const insuranceCompany = productData.product.insurer_name;
        const productScenarioCode = productData.product.scenario_code;
        const productName = productData.product.product_name;
        const productCategory = productData.product.product_category;
        eventTrackingParams.a = 'product_website';
        eventTrackingParams.l = productScenarioCode;
        eventTrackingParams.c = `product_details_cta`;
        eventTrackingParams.cd.insurer_name = insuranceCompany;
        eventTrackingParams.cd.product_name = productName;
        eventTrackingParams.cd.product_category = productCategory;

        this.openWindowWithLGMUrl(event, '.product-highlight-cta-link.product-website', eventTrackingParams, 'transitionLink');

      } else if (dataFromClickedElement.tracking_target.target_code === 'product-highlight-cta-link') {
        // #12 and #86
        if (this.isTransitionLink(href)) {
          // #12 to insurer page via TransitionLink
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'click_redirection';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `product_details_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.openWindowWithLGMUrl(event, '.product-highlight-cta-link', eventTrackingParams, 'transitionLink');

        } else if (this.isWhatsappLink(href)) {
          // #86 url is Whatsapp link
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'open_whatsapp';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `product_details_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;


          this.$goToURL(href, false, eventTrackingParams, {
            getLGMConversionId: this.getLGMConversionId
          });

        } else if (this.isEComLink(href)) {
          // #147 url is ECom site link
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'to_ecom_site';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `product_details_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.openWindowWithLGMUrl(event, '.product-highlight-cta-link', eventTrackingParams, 'eCommerceSite');

        } else {
          // #12 to insurer page non TransitionLink
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'click_redirection';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `product_details_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.openWindowWithLGMUrl(event, '.product-highlight-cta-link', eventTrackingParams, 'transitionLink');

        }
      } else if (dataFromClickedElement.tracking_target.target_code === 'product-promo-more') {
        // #54 product_details_promo_banner
        const productData = this.extractDataFromCurrentProductDetailPage();
        const insuranceCompany = productData.product.insurer_name;
        const productScenarioCode = productData.product.scenario_code;
        const productName = productData.product.product_name;
        const productCategory = productData.product.product_category;
        eventTrackingParams.a = 'open_promo_details';
        eventTrackingParams.l = productScenarioCode;
        eventTrackingParams.c = `product_details_promo_banner`;
        eventTrackingParams.cd.insurer_name = insuranceCompany;
        eventTrackingParams.cd.product_name = productName;
        eventTrackingParams.cd.product_category = productCategory;

      } else if (dataFromClickedElement.tracking_target.target_code === 'product-promo-cta') {
        event.preventDefault();
        if (this.isEComLink(href)) {
          // #146 product_details_promo_cta
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'to_ecom_site';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `product_details_promo_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.openWindowWithLGMUrl(event, '.product-promo-cta', eventTrackingParams, 'eCommerceSite');
        } else if (this.$isWhatsappLink(href)) {
          // #154a product_details_promo_cta
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'open_whatsapp';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `product_details_promo_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.$goToURL(dataFromClickedElement.href, false, eventTrackingParams, {
            getLGMConversionId: this.getLGMConversionId,
            injectLGMConversionId: this.injectLGMConversionId,
            injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
          });

          window.open(href, "_blank");
        } else {
          // #13 product_details_promo_cta
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'click_redirection';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `product_details_promo_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.openWindowWithLGMUrl(event, '.product-promo-cta', eventTrackingParams, 'transitionLink');
        }
      }

      this.sendEventTracking(eventTrackingParams);
    },
  },
};
